'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 10px;\n  background-color: ', ';\n  outline: none;\n  border: none;\n'], ['\n  margin: 0 10px;\n  background-color: ', ';\n  outline: none;\n  border: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 14px;\n  outline: none;\n  color: ', ';\n  border: none;\n  width: 100%;\n  height: 22px;\n\n  p {\n    display: inline;\n    margin-right: 10px;\n  }\n\n  span {\n    display: inline;\n    font-size: 0.7em;\n    color: ', ';\n  }\n\n  &:hover, &:focus {\n    color: ', ';\n\n    span {\n      color: ', ';\n    }\n  }\n'], ['\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 14px;\n  outline: none;\n  color: ', ';\n  border: none;\n  width: 100%;\n  height: 22px;\n\n  p {\n    display: inline;\n    margin-right: 10px;\n  }\n\n  span {\n    display: inline;\n    font-size: 0.7em;\n    color: ', ';\n  }\n\n  &:hover, &:focus {\n    color: ', ';\n\n    span {\n      color: ', ';\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-right: 10px;\n'], ['\n  display: inline-block;\n  margin-right: 10px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  border-radius: 5px;\n  background-color: ', ';\n  box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  min-width: 120px;\n  position: absolute;\n  margin-top: ', ';\n\n  a {\n    cursor: pointer;\n    padding: 0 12px;\n    float: none;\n    color: ', ';\n    font-size: 12px;\n    line-height: 29px;\n    text-decoration: none;\n    display: block;\n    text-align: left;\n    border-bottom: 1px solid ', ';\n\n  }\n\n  a:last-child {\n    border-bottom: none;\n  }\n\n  a:hover {\n    border-radius: 5px;\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  border-radius: 5px;\n  background-color: ', ';\n  box-shadow: 0 2px 6px -2px rgba(0,0,0,0.5);\n  min-width: 120px;\n  position: absolute;\n  margin-top: ', ';\n\n  a {\n    cursor: pointer;\n    padding: 0 12px;\n    float: none;\n    color: ', ';\n    font-size: 12px;\n    line-height: 29px;\n    text-decoration: none;\n    display: block;\n    text-align: left;\n    border-bottom: 1px solid ', ';\n\n  }\n\n  a:last-child {\n    border-bottom: none;\n  }\n\n  a:hover {\n    border-radius: 5px;\n    background-color: ', ';\n    color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Dropdown = _styledComponents2.default.div(_templateObject, _color2.default.white);

var Dropbtn = _styledComponents2.default.div(_templateObject2, _color2.default.grey_main, _color2.default.blue_accent, _color2.default.blue_accent, function (props) {
  return props.icon ? _color2.default.white : _color2.default.orange_main;
});

var DropTxt = _styledComponents2.default.div(_templateObject3);

var DropdownContent = _styledComponents2.default.div(_templateObject4, _color2.default.purple_accent, function (props) {
  return props.icon ? '2em' : '2px';
}, _color2.default.blue_main, _color2.default.blue_accent, _color2.default.blue_accent, _color2.default.white);

var MozartNavigationItem = function (_Component) {
  _inherits(MozartNavigationItem, _Component);

  function MozartNavigationItem(props) {
    _classCallCheck(this, MozartNavigationItem);

    var _this = _possibleConstructorReturn(this, (MozartNavigationItem.__proto__ || Object.getPrototypeOf(MozartNavigationItem)).call(this, props));

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(MozartNavigationItem, [{
    key: 'getItemList',
    value: function getItemList(items) {
      var _this2 = this;

      var DATA = [];
      items.forEach(function (item, index) {
        DATA.push(_react2.default.createElement(
          'a',
          { key: index, onClick: _this2.handleClick.bind(_this2, item) },
          item.itemData
        ));
      });
      return DATA;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(item) {
      var previousUrl = window.location.href;
      this.hide(function () {
        if (item.itemValue) {
          window.location.href = item.itemValue;
        }
        if (item.onClick) {
          item.onClick(previousUrl);
        }
      });
    }
  }, {
    key: 'hide',
    value: function hide(callback) {
      var _this3 = this;

      var ieBrowser = false;
      if ((0, _utils.checkBrowser)() === 'ie') {
        ieBrowser = true;
      }
      setTimeout(function () {
        _this3.setState({ show: false }, function () {
          if (callback && typeof callback === 'function') {
            callback();
          }
        });
      }, ieBrowser ? 500 : 60);
    }
  }, {
    key: 'show',
    value: function show() {
      this.setState({ show: !this.state.show });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          icon = _props.icon,
          contentStyle = _props.contentStyle,
          items = _props.items,
          style = _props.style,
          onClick = _props.onClick,
          themeId = _props.themeId;

      return _react2.default.createElement(
        Dropdown,
        { 'data-qa': this.props.testId, tabIndex: '0', style: style, onClick: onClick, onBlur: this.hide.bind(this), 'data-theme': themeId },
        _react2.default.createElement(
          Dropbtn,
          { icon: icon, onClick: this.show.bind(this) },
          _react2.default.createElement(
            DropTxt,
            null,
            data
          ),
          !icon && _react2.default.createElement('span', { className: 'icon-Down' })
        ),
        this.state.show && _react2.default.createElement(
          DropdownContent,
          { style: contentStyle, icon: icon },
          this.getItemList(items)
        )
      );
    }
  }]);

  return MozartNavigationItem;
}(_react.Component);

MozartNavigationItem.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** if true hide arrow down button */
  icon: _propTypes2.default.bool,
  /** label of navigation item */
  data: _propTypes2.default.string.isRequired,
  /** array of dropdown items objects {itemData: , itemValue: , onClick } */
  items: _propTypes2.default.array,
  /** override style */
  style: _propTypes2.default.object,
  /** override content style */
  contentStyle: _propTypes2.default.object,
  /** callback on click */
  onClick: _propTypes2.default.func
};
MozartNavigationItem.defaultProps = {
  icon: false,
  items: [],
  style: {},
  testId: 'MozartNavigationItem',
  themeId: 'MozartNavigationItem',
  currentPage: false
};
exports.default = MozartNavigationItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartNavigation/MozartNavigationItem/MozartNavigationItem.js
// module id = 716
// module chunks = 1